import React from 'react'
import NewSnack from '../NewSnack'
import '../styles/new.css'
export default function New() {
  return (
    <div>
      <NewSnack/>
    </div>
  )
}
